import { ChangeEvent, useId, useState } from 'react'

import Block from '@/layouts/block'
import { CheckBoxInputField } from '@/components/input'
import { P1, P2 } from '@/components/typography'
import FormElement from '@/components/form'
import { AngleDownIcon, AngleUpIcon } from '@/components/icons'

export interface SingleFilter {
  name: string
  value: string
}

interface FiltersProps {
  filterData: SingleFilter[]
  filtersTitle: string
  filters: string[]
  handleCheckBoxChange: any
  handleToggleFilters?: (e: ChangeEvent<HTMLInputElement>) => void
}

const FiltersBlock = ({
  className = '',
  filterData,
  handleCheckBoxChange,
  handleToggleFilters,
  filters,
  filtersTitle,
  isOpen = false,
}: FiltersProps & { className?: string; isOpen?: boolean }) => {
  const id = useId()
  const [filtersOpen, setFiltersOpen] = useState<boolean>(isOpen)
  const toggleFiltersOpen = () => setFiltersOpen(!filtersOpen)

  const allFiltersOn = filterData.every((singleValue) => {
    return filters.includes(singleValue.name)
  })

  const renderFilterIcon = filtersOpen ? <AngleUpIcon /> : <AngleDownIcon />

  return (
    <Block className={`filters ${className}`}>
      <FormElement initialValues={['']} submitForm={handleCheckBoxChange}>
        <div
          onClick={toggleFiltersOpen}
          className="mb-2 mt-8 flex gap-1 items-center cursor-pointer"
        >
          <P2>{filtersTitle}</P2> {renderFilterIcon}
        </div>
        {/* this is a niche component for ons-team page. Might be changed later to be dynamic */}
        {handleToggleFilters && filtersOpen && (
          <CheckBoxInputField
            onChange={handleToggleFilters}
            name="Alle teams"
            value={allFiltersOn}
            wrapperClassName="my-4"
          >
            <P1>Alle teams</P1>
          </CheckBoxInputField>
        )}
        {filtersOpen &&
          filterData.map((singleValue, index) => {
            const isChecked = filters.includes(singleValue.name)
            return (
              <CheckBoxInputField
                key={`${id}-${index}`}
                onChange={handleCheckBoxChange}
                name={singleValue.name}
                value={isChecked}
                wrapperClassName="my-4"
              >
                <P1>{singleValue.value}</P1>
              </CheckBoxInputField>
            )
          })}
      </FormElement>
    </Block>
  )
}

export default FiltersBlock
